const TAG = '[Dashboard SDK]';

export function validateArray(arg: any, message: string) {
  if (!Array.isArray(arg)) {
    throw new Error(`${TAG} ${message}`);
  }
}

export function validateString(arg: any, message: string) {
  if (typeof arg !== 'string') {
    throw new Error(`${TAG} ${message}`);
  }
}

export function validateObject(arg: any, message: string) {
  if (!(arg instanceof Object) || arg instanceof Array) {
    throw new Error(`${TAG} ${message}`);
  }
}

export function validateBool(arg: any, message: string) {
  if (typeof arg !== 'boolean') {
    throw new Error(`${TAG} ${message}`);
  }
}

export function validateFunction(arg: any, message) {
  if (typeof arg !== 'function') {
    throw new Error(`${TAG} ${message}`);
  }
}
